import { render, staticRenderFns } from "./MortgageCardComponent.vue?vue&type=template&id=289f5162"
import script from "./MortgageCardComponent.vue?vue&type=script&lang=js"
export * from "./MortgageCardComponent.vue?vue&type=script&lang=js"
import style0 from "./MortgageCardComponent.vue?vue&type=style&index=0&id=289f5162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports